import { useEffect } from "react";
import "./App.css";
import axios from "axios";
import AppRoutes from "./routes";
import Navbar from "./components/navbar";
import { fetchUserInfo, getCookie } from "./utils";
import { useLocation } from "react-router-dom";
import { useToken, useUser } from "./global_state";
import { usePostHog } from "posthog-js/react";
import { BottomNav } from "./components/bottom-nav";

function App() {
  const location = useLocation();
  const [user, setUser] = useUser();
  const [authToken, setAuthToken] = useToken();

  const posthog = usePostHog();

  const setCSRFCookie = () => {
    axios.interceptors.request.use(function (config) {
      const cookie = getCookie("csrftoken");
      config.headers["X-CSRFToken"] = cookie;
      return config;
    });
  };

  useEffect(() => {
    setCSRFCookie();
    axios.defaults.headers.common["Content-Type"] = "application/json";
    const token = localStorage.getItem("auth_token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;
      if (!user) {
        fetchUserInfo(location, posthog, setUser);
      }
      setAuthToken(token);
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    setAuthToken(null);
  };
  if (!location.pathname.startsWith("/app")) {
    return <AppRoutes />;
  }

  return (
    <div>
      <Navbar user={user} logout={logout} />
      <AppRoutes />
      {location.pathname.startsWith("/app") && <BottomNav />}
    </div>
  );
}

export default App;
